<div class="se-external-docs-tree">
    <div *ngFor="let documents of externalDocuments; let i = index"
         class="se-external-docs-tree-item">
        <div style='display:flex;align-items:center'>
            <div mat-card-avatar style="height:32px;width:32px;" class="fab-selection-button">
                <mat-icon *ngIf='documents.type === 0' style="font-size:24px;margin:4px">person</mat-icon>
                <mat-icon *ngIf='documents.type === 1' style="font-size:24px;margin:4px">insert_drive_file</mat-icon>
            </div>
            <h2  class="mat-h2 se-external-docs-description">{{documents.description}}</h2>

            <button mat-button
                    color="primary"
                    style="font-size:1em; margin:10px;align-self: flex-end;"
                    type="button"
                    (click)="fileInput.click()">
                <p class="mat-small se-external-docs-mat-card-import" style="margin:0" translate>ImportNewDocument</p>
                <input #fileInput type="file" (change)="onHandleFileInput($event.target.files, documents)" style="display:none;" accept=".jpg,.jpeg,.png,.pdf" />
            </button>
        </div>

        <mat-card appearance="outlined" (click)="onSelect(document)" *ngFor="let document of documents.linkedExternalDocuments;"
                  class="se-external-docs-tree-mat-card" [class.se-card-selected]="isDocSelected(document)" [class.se-external-docs-selected-mat-card]="isDocSelected(document)">
            <mat-card-header>

                <div mat-card-avatar [class.se-external-docs-selected-mat-card-color]="isDocSelected(document)">
                    <mat-icon *ngIf='document.fileType === 1' style="font-size:24px">picture_as_pdf</mat-icon>
                    <mat-icon *ngIf='document.fileType === 2' style="font-size:24px">image</mat-icon>
                    <mat-icon *ngIf='document.fileType === 3' style="font-size:24px">image</mat-icon>
                </div>

                <mat-card-title class="mat-h3;" class="se-external-docs-mat-card-title">{{getCardTitle(document)}}</mat-card-title>
                <mat-card-subtitle *ngIf='documents.type === 0' class="mat-h4 se-external-docs-mat-card-subtitle" style="margin-bottom: 2px;">{{getDateForPatient(document)}}</mat-card-subtitle>
                <mat-card-subtitle *ngIf='documents.type === 0' class="mat-h4 se-external-docs-mat-card-subtitle">{{getDossierStatus(document)}}</mat-card-subtitle>
                <mat-card-subtitle *ngIf='documents.type === 1' class="mat-h4 se-external-docs-mat-card-subtitle">{{getDateForStudy(document)}}</mat-card-subtitle>

            </mat-card-header>
            <mat-card-content style="margin-bottom:0">
                <p class="mat-caption se-external-docs-mat-card-caption">
                    Descrizione: {{document.eprDescription}}
                </p>
            </mat-card-content>
            <mat-card-actions style="padding: 0; display: flex; flex-direction: row-reverse;">
                <button mat-button
                        class="se-external-docs-action-button"
                        [class.se-external-docs-selected-mat-card-color]="isDocSelected(document)"
                        [class.se-external-docs-not-selected-mat-card-button]="!isDocSelected(document)"
                        [disabled]="disableButton"
                        type="button"
                        (click)="onDeleteDocumentRequired(document)">
                    <p class="mat-small" style="margin:0" translate>Delete</p>
                </button>
                <button mat-button
                        class="se-external-docs-action-button"
                        [class.se-external-docs-selected-mat-card-color]="isDocSelected(document)"
                        [class.se-external-docs-not-selected-mat-card-button]="!isDocSelected(document)"
                        [disabled]="disableButton"
                        type="button"
                        (click)="onEditDocumentRequired(document)">
                    <p class="mat-small" style="margin:0" translate>Modify</p>
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
